import * as z from "zod";
export const Table = z.object({
    type: z.literal("table"),
    value: z.object({
        headers: z.string().array(),
        bodies: z.string().array().array(),
    }),
});
